import styled from 'styled-components';

const UserProfileWrapper = styled.div`

.SpinerWrapper{
    display: flex;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
}

.TextBtnH3{
    font-size: 18px;
    font-family: "Kanit";
}

.ButtonRightFixed{
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;
}

.facilityImageGridWrapper{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) ;
    grid-gap: 20px;
    background-color: #fff;
    color: #444;
  }

.facilityTitleTextContainer{
    display: flex;
    justify-content: center;
}

.facilityTitleText{
    font-size: 18px;
    font-family: "Kanit";
}
 
.facilityDescriptionTextContainer{
    display: flex;
    justify-content: center;
}

.facilityDescriptionText{
    font-size: 16px;
    font-family: "Kanit";
    text-align: center;
}

// .avatarImageContainer {
//     position:relative;
// }

.avatarImageIcon {
    position: absolute;
    top: 10px;
    right: 10px;
}

.avatarImageContainer {
    position: relative;
    text-align: center;
    color: white;
    height: 128px;
}

.featureImageBGImage{
    border-radius: 8px;
    // width: 400px;
    max-width: 100%;
    height: 312px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat,    
}

.featureImageBGImage::after {
    display: block;
    position: relative;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, #000 200%);
    height: 100%;
    max-width: 100%;
    content: '';
    border-radius: 8px;
}


.avatarEditIconTopRight{
    position: absolute;
    z-index: 10;
    color: white;
    top: 0px;
    right: 0px;
}

.featureImageH2BottomLeft{
    position: absolute;
    z-index: 10;
    font-size: 20px;
    font-family: "Kanit";
    color: white;
    position: absolute;
    bottom: 8px;
    left: 16px;
}


.featureImageH1BottomCenter{
    position: absolute;
    z-index: 10;
    font-size: 24px;
    font-family: "Kanit";
    font-weight: bold;
    color: white;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translate(-50%, -50%);
}

.featureImageH2BottomCenter{
    position: absolute;
    z-index: 10;
    font-size: 20px;
    font-family: "Kanit";
    color: white;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translate(-50%, -50%);
}


`
export default UserProfileWrapper;